import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import authReducer, { overrideSubdomainAction, tokenAction } from './auth/reducers';
import { startSessionRenewal } from 'utils/session';
import { getStoredAuthToken } from '../utils/authToken';
import signUpReducer from './signUp/reducers';
import devicesReducer from './devices/reducers';
import forgotPassword from './forgotPassword/reducers';
import chartReducer from './charts/reducers';
import usersReducer from './users/reducers';
import locationReducer from './locations/reducers';
import productsReducer from './productClasses/reducers';
import productReducer from './products/reducers';
import productClassReducer from './productClass/reducers';
import inventoryLocationReducer from './inventoryLocation/reducers';
import abacReducer from './abac/reducers';
import entitlementsReducer from './entitlements/reducers';
import cartReducer from './cart/reducers';
import afmsTanksReducer from 'afms/redux-store/tanks/reducers';
import afmsBinsReducer from 'afms/redux-store/bins/reducers';
import afmsPickupsReducer from 'afms/redux-store/pickups/reducers';
import afmsDashboardReducer from 'afms/redux-store/dashboard/reducers';
import afmsVendorsReducer from 'afms/redux-store/vendors/reducers';
import afmsRedistributionReducer from 'afms/redux-store/redistribution/reducers';
import afmsNotificationsReducer from 'afms/redux-store/notifications/reducers';
import afmsInventoryReducer from 'afms/redux-store/inventory/reducers';
import afmsInspectionsReducer from 'afms/redux-store/inspections/reducers';
import afmsMaintenanceReducer from 'afms/redux-store/maintenance/reducers';
import afmsLocationsReducer from 'afms/redux-store/locations/reducers';
import afmsSpccReducer from 'afms/redux-store/spcc/reducers';
import afmsTankNotificationRulesReducer from 'afms/redux-store/tankNotificationRules/reducers';
import afmsSpccScreeningReducer from 'afms/redux-store/spccScreening/reducers';
import afmsTrainingReducer from 'afms/redux-store/training/reducers';
import afmsIncidentsReducer from 'afms/redux-store/incidents/reducers';
import afmsLotoReducer from 'afms/redux-store/loto/reducers';
import afmsBriefingReducer from 'afms/redux-store/briefing/reducers';
import afmsPortalReducer from 'afms/redux-store/portal/reducers';
import afmsApprovalsReducer from 'afms/redux-store/approvals/reducers';
import afmsVendorFinancialReducer from 'afms/redux-store/vendorFinancial/reducers';
import afmsReportingReducer from 'afms/redux-store/reporting/reducers';
import afmsDispatchReducer from 'afms/redux-store/dispatch/reducers';
import afmsCommandCenterReducer from 'afms/redux-store/commandCenter/reducers';
import { setAxios } from 'helpers';
import { seedAuthTokenFromSharedCookie } from "../utils/sharedAuthCookie";

setAxios()

const store = configureStore({
  reducer: {
    auth: authReducer,
    signUp: signUpReducer,
    devices: devicesReducer,
    forgotPassword: forgotPassword,
    charts: chartReducer,
    users: usersReducer,
    location:locationReducer,
    products:productsReducer,
    product: productReducer,
    productClass: productClassReducer,
    inventoryLocation: inventoryLocationReducer,
    abac: abacReducer,
    entitlements: entitlementsReducer,
    afmsTanks: afmsTanksReducer,
    afmsBins: afmsBinsReducer,
    afmsPickups: afmsPickupsReducer,
    afmsDashboard: afmsDashboardReducer,
    afmsVendors: afmsVendorsReducer,
    afmsRedistribution: afmsRedistributionReducer,
    afmsNotifications: afmsNotificationsReducer,
    afmsInventory: afmsInventoryReducer,
    afmsInspections: afmsInspectionsReducer,
    afmsMaintenance: afmsMaintenanceReducer,
    afmsLocations: afmsLocationsReducer,
    afmsSpcc: afmsSpccReducer,
    afmsTankNotificationRules: afmsTankNotificationRulesReducer,
    afmsSpccScreening: afmsSpccScreeningReducer,
    afmsTraining: afmsTrainingReducer,
    afmsIncidents: afmsIncidentsReducer,
    afmsLoto: afmsLotoReducer,
    afmsBriefing: afmsBriefingReducer,
    afmsPortal: afmsPortalReducer,
    afmsApprovals: afmsApprovalsReducer,
    afmsVendorFinancial: afmsVendorFinancialReducer,
    afmsReporting: afmsReportingReducer,
    afmsDispatch: afmsDispatchReducer,
    afmsCommandCenter: afmsCommandCenterReducer,
    cart: cartReducer,
  }
});

// Before reading localStorage: this origin may have no token while a sibling
// host of the same domain is signed in.
seedAuthTokenFromSharedCookie();

const storedAuthToken = getStoredAuthToken();
if (storedAuthToken) store.dispatch(tokenAction(storedAuthToken));

if (localStorage._subdomain) store.dispatch(overrideSubdomainAction(localStorage._subdomain));

// Renew the session before its tokens expire (see utils/session).
startSessionRenewal();

export default store;